import PhUserGear from 'ember-phosphor-icons/components/ph-user-gear';
import PhCalendarCheck from 'ember-phosphor-icons/components/ph-calendar-check';
import PhCurrencyEur from 'ember-phosphor-icons/components/ph-currency-eur';
import PhClipboardText from 'ember-phosphor-icons/components/ph-clipboard-text';
import PhBroom from 'ember-phosphor-icons/components/ph-broom';
import PhWrench from 'ember-phosphor-icons/components/ph-wrench';
import PhBuildings from 'ember-phosphor-icons/components/ph-buildings';
import PhCrown from 'ember-phosphor-icons/components/ph-crown';
import { InvitationSubrole } from 'uplisting-frontend/models/invitation';
import { UserRoles } from 'uplisting-frontend/models/user';
import type { PersonRoleKey } from 'uplisting-frontend/utils/teammate-people';

export const ICON_FOR_ROLE = {
  [UserRoles.host]: PhUserGear,
  [InvitationSubrole.reservations]: PhCalendarCheck,
  [InvitationSubrole.finance]: PhCurrencyEur,
  [InvitationSubrole.operations]: PhClipboardText,
  [UserRoles.housekeeper]: PhBroom,
  [InvitationSubrole.maintenance]: PhWrench,
  [UserRoles.owner]: PhBuildings,
  [UserRoles.accountOwner]: PhCrown,
} as const;

export type RoleIcon = (typeof ICON_FOR_ROLE)[PersonRoleKey];

export function iconForRole(key: PersonRoleKey): RoleIcon {
  return ICON_FOR_ROLE[key];
}
